import React from 'react';

import { Tag, TagLabel, TagCloseButton } from '@chakra-ui/react';
import { themeColors } from 'themes/clients/baseTheme';

import { CloseIconChip } from 'assets/assetsV1/iconComponents';

export default function CustomTagChip({
  tag = {},
  isShowCloseButton = false,
  onTagClose = () => {},
  tagNameLengthLimit = 8,
}) {
  return (
    <Tag
      size="md"
      borderRadius="6px"
      py="8px"
      variant="solid"
      backgroundColor={themeColors.neutral.F2F2F2}
      color={themeColors.text.g1}
      fontWeight={400}
      fontSize="14px"
      minWidth="max-content"
      padding="0 4px 0 4px"
      boxShadow="0px 0px 1px 0px rgba(0, 0, 0, 0.25)"
    >
      <TagLabel>
        {tag.tagName.length > tagNameLengthLimit ? `${tag.tagName.slice(0, tagNameLengthLimit)}...` : tag.tagName}
      </TagLabel>
      {isShowCloseButton && (
        <TagCloseButton
          onClick={() => {
            onTagClose(tag);
          }}
        >
          <CloseIconChip color="black" />
        </TagCloseButton>
      )}
    </Tag>
  );
}
